import React from "react";
import { Link } from "react-router-dom";

function RoomCard({ image, title, link, beds, baths, guests }) {
  return (
    <div className="villa-card wow fadeInUp" data-wow-delay="100ms">
      <div className="villa-card__image">
        <Link to={link}>
          <img src={image} alt={title} />
        </Link>
      </div>
      <div className="villa-card__content">
        <h3 className="villa-card__title bt_padding">
          <Link to={link}>{title}</Link>
        </h3>
        <ul className="list-unstyled villa-card__meta">
          <li>
            <span className="icon-bed" />
            {beds}
          </li>
          <li>
            <span className="icon-bath" />
            {baths}
          </li>
          <li>
            <span className="icon-users" />
            {guests}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default RoomCard;
